module.exports = __webpack_public_path__ + "img/ic_audio.51b8b099.svg";